var map = {
	"./the-futsal-directory-launches.md.js": 266,
	"./the-mystery-of-the-lucozade-court.md.js": 240,
	"./time-to-rethink-futsal-competition-formats.md.js": 545,
	"./venue-spotlight-antarès-le-mans.md.js": 817,
	"./venue-spotlight-domo-polideportivo.md.js": 780,
	"./venue-spotlight-fmf-futsal-arena.md.js": 955,
	"./venue-spotlight-hohhot-sports-centre.md.js": 508,
	"./venue-spotlight-palacio-de-los-deportes.md.js": 823,
	"./venue-spotlight-prince-moulay-abdullah-hall.md.js": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;